<template>
	<Modal @close="$emit('close')" :modalWidth="70">
		<template v-slot:title>
			Pick up History
		</template>

		<template v-slot:body>
			<PackingPerStaff :component_of_modal="true" />
		</template>
	</Modal>
</template>

<script>
import PackingPerStaff from '@/views/report/PackingPerStaff.vue';
import Modal from '@/components/common/Modal.vue';
export default {
	components: {
		Modal,
		PackingPerStaff,
	},
};
</script>

<style></style>
